import React, { useEffect } from "react";

import getContentById from "../../../../shared/utils/getContentById";
import _ from "lodash";
import TemplateBlock from "../../_partials/TemplateBlock/Index";
import prepareVideoBg from "../../../../shared/functions/prepareVideoBg";
import animationScript, {
  animationCleanUp,
} from "./animations";

import assets from "./assets";
import getOptaCountryCode from "../../../../shared/utils/getOptaCountryCode";
import { useTranslation } from "react-i18next";
import {
  getTeamGoalmouth,
} from "../../../../shared/utils/opta/statsHandler";
import Image from "../../../../shared/components/Image";
import {
  getDynamicLogoPath,
  toIsoDateString,
} from "../../../../shared/utils/functions";
import ProgressBar from "../../../../shared/components/ProgressBar";
import { MatchScoreWidget } from "../../_partials/MatchScoreWidget/MatchScoreWidgetForBild";

require("./style/style.scss");
require("./style/animation.scss");

export const translatePosition = ({
  leftPercent,
  topPercent,
  maxRight,
  maxLeft,
  maxHigh,
}) => {
  // Calculate the range for left and top positions
  const leftRange = maxLeft - maxRight;
  const topRange = maxHigh;

  // Scale the percentage values to fit within the restricted area
  const scaledLeft = ((leftPercent - maxRight) / leftRange) * 100;
  const scaledTop = ((maxHigh - topPercent) / topRange) * 100;

  // Mirror the scaled left position to switch sides (from right to left)
  // const mirroredLeft = 100 - scaledLeft;

  // Return the scaled left and top positions as an object
  return {
    left: scaledLeft,
    top: scaledTop,
  };
};

const Index = (props) => {
  const refs = {
    player: React.createRef(),
    team: React.createRef(),
  };

  const {
    animation,
    data,
    images: Images,
    apiSetup,
    mode,
    format,
    isTimeline,
  } = props;

  const id = `${_.get(data, "template_name", "")}_${_.get(data, "uuid", "")}`;
  const { t } = useTranslation();

  const prepareAnimation = () => {
    prepareVideoBg({ id });
  };

  useEffect(() => {
    let animationReturn = null;
    if (mode === "animation" || mode === "video") {
      if (animation) {
        prepareAnimation();
        animationReturn = animationScript({
          refs,
          data,
          animation,
          mode,
          id,
          format,
          apiSetup,
          templateName: data?.template_name
        });
      }
    }

    //handle outro video BEGIN
    // if(mode === "video" && !isTimeline) {
    //   const outroVideo = $(`#${id} video.outro-optional-video`);
    //   outroVideo.get(0).addEventListener("loadedmetadata", function() {
    //       const that = this;
    //       setTimeout(()=> {
    //         outroVideo?.css('opacity', 1);
    //         this.currentTime = 0;
    //         that.play();
    //       }, frontendCfg.showOutroAfter)
    //     }, false);
    // }
    //handle outro video END

    return function cleanUp() {
      if (animationReturn) {
        animationCleanUp(animationReturn);
      }
    };
  }, [animation, mode]);

  const templateData = _.get(data, "data");

  const { options, fields, dynamic } = templateData;
  const matchInfo = _.get(dynamic, "optaMatchInfo");
  const goalShots = _.get(dynamic, "goalShots");
  const matchStats = _.get(dynamic, "matchStats");

  const competitionId = matchInfo?.competition?.id;

  const homeTeam = _.find(matchInfo?.contestant, { position: "home" });
  const awayTeam = _.find(matchInfo?.contestant, { position: "away" });
  const teamSide = getContentById("selectedSide", fields);

  const teamShots = _.filter(goalShots, (o) => {
    if (o.isOwnGoal) {
      if (
        (teamSide === "away" && o.contestantId === homeTeam?.id) ||
        (teamSide === "home" && o.contestantId === awayTeam?.id)
      ) {
        return true;
      }
      return false;
    }

    return o.contestantId === (teamSide === "home" ? homeTeam?.id : awayTeam?.id);
  });

  const homeStats = _.get(matchStats, "liveData.lineUp.0.stat");
  const awayStats = _.get(matchStats, "liveData.lineUp.1.stat");
  const statsMappingHome = getTeamGoalmouth(homeStats, awayStats);
  // const json = JSON.stringify(homeStats, null, 2);
  // const blob = new Blob([json], { type: "application/json" });
  // const url = URL.createObjectURL(blob);

  // const link = document.createElement("a");
  // link.href = url;
  // link.download = "data.json";
  // link.click();

  // URL.revokeObjectURL(url);
  const statsMappingAway = getTeamGoalmouth(awayStats, homeStats);

  const statsBySide = teamSide === "home" ? statsMappingHome : statsMappingAway;
  const bildMatchInfo = _.get(dynamic, "matchInfo");
  const bildHomeTeam = bildMatchInfo?.home;
  const bildAwayTeam = bildMatchInfo?.away;
  console.log('awayStats: ', awayStats)
  return (
    <div
      id={id}
      className={`T_${_.get(data, "template_name", "")} ${animation ? "animation" : ""
        } side-${_.get(dynamic, "teamSide")}`}
    >
      <TemplateBlock class={`${isTimeline ? "" : "template-bild"}`}>
        {
          !isTimeline && <div className="main-header-content">
            <div className="main-header">
              {t("Shots on goal", { keyPrefix: "templates" })}
            </div>
            <MatchScoreWidget
              homeTeam={bildHomeTeam}
              awayTeam={bildAwayTeam}
              matchInfo={bildMatchInfo}
            />
          </div>
        }
        <div className={"wc-content wc-content-v2"}>
          <ProgressBar height={"8px"} />

          <div className="main-content-side">
            <div className={"left-block-side"}>
              <div className={"team-logo-container"}>
                <Image
                  className="team-logo"
                  src={getDynamicLogoPath({
                    team: teamSide === "home" ? homeTeam : awayTeam,
                    competitionId,
                  })}
                />
                <div className={"team-name home"}>
                  {teamSide === "home"
                    ? t(homeTeam?.name, { ns: "countries" })
                    : t(awayTeam?.name, { ns: "countries" })}
                </div>
              </div>
            </div>


            <div className={"dynamic-content"}>
              <div className={"goalmouth-content"}>
                <img src={assets.goalmouth} />
                <div className={"layer-shots"}>
                  {_.map(teamShots, (shot, shotIndex) => {
                    const isOwnGoal = shot?.isOwnGoal;
                    const isPenalties = shot?.periodId == 5;
                    const typeToColor = {
                      Goal: "goal",
                      "Attempt Saved": "saved",
                      Post: "post",
                      Penalty: "penalties",
                    };

                    let targetColorType = typeToColor[shot?.eventTypeLabel];

                    if (isPenalties) {
                      targetColorType = typeToColor["Penalty"];

                      return null;
                    }

                    const goalCoordsParams = {
                      maxHigh: 42.0,
                      maxRight: 44.2,
                      maxLeft: 55.8,
                    }; //included BARS

                    const leftPercent = shot?.goalY;
                    const topPercent = shot?.goalZ;

                    const translations = translatePosition({
                      leftPercent,
                      topPercent,
                      ...goalCoordsParams,
                    });

                    return (
                      <div
                        key={"shot-" + shot.eventId}
                        data-y={translations.top}
                        data-z={translations.left}
                        data-goalposition={shot?.goalPositionLabel}
                        className={`shot color-${targetColorType} ${isOwnGoal ? "own-goal" : ""
                          }`}
                        data-event={shot?.entryTypeLabel}
                        data-player={shot?.playerName}
                        data-time={`${shot?.timeMin}:${shot?.timeSec}`}
                        style={{
                          right: `${translations.left}%`,
                          top: `${translations.top}%`,
                        }}
                      >
                        {/*{shotIndex+1}*/}
                      </div>
                    );
                  })}
                </div>
              </div>

              <div className={"field-content"}>
              <img src={assets.goalmouth_field} />
              <div className={"layer-positions"}>
                {_.map(teamShots, (shot, shotIndex) => {
                  const isOwnGoal = shot?.isOwnGoal;
                  const isPenalties = shot?.periodId == 5;
                  const typeToColor = {
                    Goal: "goal",
                    "Attempt Saved": "saved",
                    Post: "post",
                    Penalty: "penalties",
                  };

                  let targetColorType = typeToColor[shot?.eventTypeLabel];

                  if (isPenalties) {
                    targetColorType = typeToColor["Penalty"];
                    return null;
                  }

                  const leftPercent = shot?.y;
                  const topPercent = isOwnGoal ? (shot?.x) * 2.25 : (100 - shot?.x) * 2.25;

                  return (
                    <div
                      key={"position-" + shot.eventId}
                      data-y={topPercent}
                      data-x={leftPercent}
                      data-goalposition={shot?.goalPositionLabel}
                      className={`shot color-${targetColorType} ${isOwnGoal ? "own-goal" : ""
                        }`}
                      data-event={shot?.entryTypeLabel}
                      data-player={shot?.playerName}
                      data-time={`${shot?.timeMin}:${shot?.timeSec}`}
                      style={{
                        right: `${leftPercent}%`,
                        top: `${topPercent}%`,
                      }}
                    >
                    </div>
                  );
                })}
              </div>
            </div>
            </div>
            <div className={"stats-block"}>
              {statsBySide.map((statRowHome, index) => {
                if (statRowHome.type === "totalScoringAtt") return;
                let statColor =
                  statRowHome.type === "calcParaden" ? "calc-paraden" : "normal";

                if (statRowHome.type === "goals") {
                  statColor = "goals";
                }

                if (statRowHome.type !== "calcParaden") {
                  return (
                    <React.Fragment key={"stats1" + statRowHome.type}>
                      <div className={`stat-row color-${statColor}`}>
                        <div className={"stat-label"}>
                          {t(statRowHome?.type, { keyPrefix: "goalStats" })}
                        </div>
                        <div className={"stat-value"}>
                          {statRowHome?.value || "-"}
                          {/*{hasPenalty && statRowHome.type === "goals" ? <span className={"color-penalties"}>({penaltyValue})</span> : ''}*/}
                        </div>
                      </div>
                    </React.Fragment>
                  );
                } else if (statRowHome.type === "calcParaden") {
                  return (
                    <React.Fragment key={"stats2" + statRowHome.type}>
                      <div className={`stat-row color-${statColor}`}>
                        <div className={"stat-label"}>
                          {t(statRowHome?.type, { keyPrefix: "goalStats" })}
                        </div>
                        <div className={"stat-value"}>
                          <span>
                            {statRowHome?.value}
                            <span className={"sign"}>%</span>
                          </span>
                        </div>
                      </div>
                      {index < statsBySide.length - 1 && (
                        <div className={"stat-separator"}></div>
                      )}
                    </React.Fragment>
                  );
                }
              })}
            </div>
          </div>
        </div>


      </TemplateBlock>
    </div>
  );
};

const getMainBackground = (format, side) => {
  return _.get(assets, `background_1920`);
};

export default Index;
